import React from 'react';

const DirectionsCarSVG = ({color, width, height}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ? width : '24'}
        height={height ? height : '24'}
        viewBox="0 0 24 24"
    >
      <path
        fill={color ? color : '#ffffff'}
        fillRule="evenodd"
        d="M18.92,6.01 C18.72,5.42 18.16,5 17.5,5 L6.5,5 C5.84,5 5.29,5.42 5.08,6.01 L3.11,11.68 C3.04,11.89 3,12.11 3,12.34 L3,19.5 C3,20.33 3.67,21 4.5,21 C5.33,21 6,20.33 6,19.5 L6,19 L18,19 L18,19.5 C18,20.32 18.67,21 19.5,21 C20.32,21 21,20.33 21,19.5 L21,12.34 C21,12.12 20.96,11.89 20.89,11.68 L18.92,6.01 Z M6.5,16 C5.67,16 5,15.33 5,14.5 C5,13.67 5.67,13 6.5,13 C7.33,13 8,13.67 8,14.5 C8,15.33 7.33,16 6.5,16 Z M17.5,16 C16.67,16 16,15.33 16,14.5 C16,13.67 16.67,13 17.5,13 C18.33,13 19,13.67 19,14.5 C19,15.33 18.33,16 17.5,16 Z M5,11 L6.27,7.18 C6.41,6.78 6.79,6.5 7.22,6.5 L16.78,6.5 C17.21,6.5 17.59,6.78 17.73,7.18 L19,11 L5,11 Z"
        />
    </svg>
);

export default DirectionsCarSVG;
